import { render } from "./ListarOcorrencias.vue?vue&type=template&id=0284025c&class=custom-template"
import script from "./ListarOcorrencias.vue?vue&type=script&lang=js"
export * from "./ListarOcorrencias.vue?vue&type=script&lang=js"

import "./ListarOcorrencias.vue?vue&type=style&index=0&id=0284025c&llang=sass&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QCard,QCardSection,QInput,QPageContainer,QPage,QTable});
